import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface IGoTopIconProps extends IConDefaultType {}

function GoTopIcon({ color, className, size = 54, rotate, flip }: IGoTopIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 54 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_1788_51342)">
          <path
            d="M27 7C38.0457 7 47 15.9543 47 27C47 38.0457 38.0457 47 27 47C15.9543 47 7 38.0457 7 27C7 15.9543 15.9543 7 27 7Z"
            fill="#00C3DD"
          />
        </g>
        <path
          d="M21.7314 30.5607C21.1065 31.1464 20.0935 31.1464 19.4686 30.5607C18.8438 29.9749 18.8438 29.0251 19.4686 28.4393L25.8686 22.4393C26.4935 21.8536 27.5065 21.8536 28.1314 22.4393L34.5314 28.4393C35.1562 29.0251 35.1562 29.9749 34.5314 30.5607C33.9065 31.1464 32.8935 31.1464 32.2686 30.5607L27 25.6213L21.7314 30.5607Z"
          fill="white"
        />
        <defs>
          <filter
            id="filter0_d_1788_51342"
            x="1"
            y="4"
            width="52"
            height="52"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="3" />
            <feGaussianBlur stdDeviation="3" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.764706 0 0 0 0 0.866667 0 0 0 0.3 0" />
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1788_51342" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1788_51342" result="shape" />
          </filter>
        </defs>
      </svg>
    </i>
  );
}

export default GoTopIcon;
